import React, { useEffect, useState } from "react";
import {
  FormActions,
  InputField,
  // RadioGroup,
} from "../../../../components/Stepper/fields/inputField";
import { FaTimes } from "react-icons/fa";

const AddGroupModal = ({ onClose, handleSubmit, type, selectedGroup }) => {
  const [name, setName] = useState("");
  const [status, setStatus] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleNameChange = (e) => {
    setName(e.target.value);

    if (error && e.target.value.trim()) {
      setError("");
    }
  };

  useEffect(() => {
    if (type === "edit") {
      const { name, status } = selectedGroup;
      setName(name);
      setStatus(status);
    } else {
      setName("");
      setStatus(true);
    }
  }, [selectedGroup, type]);

  const handleFormSubmit = () => {
    if (!name.trim()) {
      setError("Group name is required");
      return;
    }

    handleSubmit({
      name,
      status,
      onClose,
      setError,
      setLoading,
    });
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50 overflow-y-auto">
      <div className="dark:bg-custom-radial bg-[#F6F6F6] rounded-lg w-[400px] shadow-lg p-6 text-[rgba(255,255,255,1)] md:w-1/3 w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold text-lightPrimary dark:text-primary-gradient">
            {type === "edit" ? "Edit Group" : "Add Group"}
          </h2>
          <button
            onClick={onClose}
            className="text-lightPrimary dark:text-darkWaring focus:outline-none"
          >
            <FaTimes fontSize={20} />
          </button>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleFormSubmit();
          }}
        >
          <div className="mb-4">
            <InputField
              label="Group Name*"
              placeholder="Enter group name"
              name="groupName"
              value={name}
              onChange={handleNameChange}
              required={false}
              errors={error}
            />
          </div>
          {/* <RadioGroup
            label="Status"
            name="status"
            value={status}
            onChange={setStatus}
            options={[
              { label: "Active", value: true },
              { label: "Inactive", value: false },
            ]}
          /> */}
          <FormActions
            loading={loading}
            onCancel={onClose}
            actionType={type}
            className="justify-end"
            submitType="submit"
          />
        </form>
      </div>
    </div>
  );
};

export default AddGroupModal;
